import { FOCUSABLE_SELECTOR } from './selector.js';

function isFocusable(element) {
    return element.matches(FOCUSABLE_SELECTOR);
}

export { isFocusable };
